// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_iZ","advertCardFooter__row":"c-a_ja","advertCardFooter__name":"c-a_jb","advertCardFooter__price":"c-a_jc","advertCardFooter__age":"c-a_je"};